var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReduceCosts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.20996 32.66L18.38 18.49",
    stroke: "#FFC92E",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.09977 23.22C7.66825 23.22 8.93976 21.9485 8.93976 20.38C8.93976 18.8115 7.66825 17.54 6.09977 17.54C4.53128 17.54 3.25977 18.8115 3.25977 20.38C3.25977 21.9485 4.53128 23.22 6.09977 23.22Z",
    fill: "#FFC92E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1098 13.1799L40.0598 28.1299L46.7398 21.4499V46.8399H21.3398L28.0298 40.1599L22.7698 34.8999",
    stroke: "#15181C",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.77 9.83984L23.77 11.8498",
    stroke: "#15181C",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4298 8.50992L19.0898 7.16992",
    stroke: "#15181C",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4698 16.5198L25.7798 5.82983",
    stroke: "#15181C",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4396 4.49991L23.0996 3.15991",
    stroke: "#15181C",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4899 33.6099C18.0584 33.6099 19.3299 32.3384 19.3299 30.7699C19.3299 29.2014 18.0584 27.9299 16.4899 27.9299C14.9214 27.9299 13.6499 29.2014 13.6499 30.7699C13.6499 32.3384 14.9214 33.6099 16.4899 33.6099Z",
    fill: "#FFC92E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReduceCosts);
export default __webpack_public_path__ + "static/media/Reduce_Costs.acbb73574808405bc942cada52eacda1.svg";
export { ForwardRef as ReactComponent };